<template lang="pug">
.row.m-0.align-items-center.w-100
  .mr-2.date
    span {{ part1 }}
    span.purple-text.ml-1 {{ part2 }}
  .flex-fill 
  .date.ml-auto(v-if="racingList.includes(source.sportsId) && source.matchTime") No. {{ part3 }}
</template>


<script>
import config from "@/config";

export default {
  props: {
    source: {
      type: Object
    }
  },
  data() {
    return {
      countDown: 0,
      ticker: null
    };
  },
  computed: {
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    part1() {
      const matchTime = this.source.matchTime;
      const timeAdjust = config.getCurrencyMinuteOffset(this.currency_code);

      const date = this.$dayjs(matchTime).subtract(timeAdjust, 'minute').format('MM/DD');
      const time = this.$dayjs(matchTime).subtract(timeAdjust, 'minute').format('HH:mm');
      const label = this.source.runningTime;
      
      return this.source.marketId < 3 ? date : (label && label.trim().length > 0 ? this.getLabel(label) : time);
    },
    part2() {
      const dateFmt = "MM/DD";
      const timeFmt = "HH:mm";
      const timeAdjust = config.getCurrencyMinuteOffset(this.currency_code);

      const mdate = this.$dayjs(this.source.matchTime).subtract(timeAdjust, 'minute').format(dateFmt);
      const mtime = this.$dayjs(this.source.matchTime).subtract(timeAdjust, 'minute').format(timeFmt);

      const mt = this.source.marketId;
      const score = this.source.runningScore;
      const label = this.source.runningTime;

      if (mt < 3) {
        return mtime;
      } else {
        if (label && label.trim().length > 0) {
          return score !== null && score.trim().length > 0 ? score.trim() : mdate;
        } else {
          return mdate;
        }
      }
    },
    part3() {
      var mdate = this.$dayjs(this.source.matchTime).format("MMDDhhmm");
      return mdate;
    },
    racingList() {
      return config.racingList;
    },
  },
  destroyed() {
  },
  mounted() {  },
  methods: {
    getLabel(e) {
      if (/\d/.test(e)) {
        return e.trim();
      }
        
      return this.$tc("m.BT_" + e.trim(), 1);
    }
  }

}
</script>